var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 mt-3 mb-3"},[_c('div',{staticClass:"col border-top"})])
}]

export { render, staticRenderFns }